<div class="wrapper">
  <div class="header">
    <div class="title">{{ title }}?</div>
    <pdq-button class="close" icon="close" variant="ghost" (onClick)="close()"></pdq-button>
  </div>
  <div class="content">
    @if (preText) {
      <span>
        {{ preText }}
      </span>
    }
    @if (!displayOrderNumbersOnly) {
      @if (state === 'Subscribe to plan') {
        <span> plan </span>
      }
      @if (selectedOrderNumbers?.length < 2 && state !== 'Subscribe to plan') {
        <span> this order </span>
      }
      @if (selectedOrderNumbers?.length >= 2) {
        <span> these orders </span>
      }
    }
    @if (!dontDisplayOrderNumbers) {
      <span>
        @for (orderNumber of selectedOrderNumbers; track orderNumber; let i = $index) {
          <span>
            #{{ orderNumber }}
            @if (i < selectedOrderNumbers?.length - 1) {
              <span>,</span>
            }
          </span>
        }
      </span>
    }
    @if (postText) {
      <span>
        {{ postText }}
      </span>
    } @else {
      <span>
        will be moved to
        {{ state.charAt(0).toUpperCase() + state.slice(1).toLowerCase() }} tab.
      </span>
    }
  </div>
  <div class="footer">
    <pdq-button [disabled]="isLoading" variant="light" label="Cancel" (onClick)="close()"></pdq-button>
    <pdq-button variant="primary" [label]="confirmLabel" (onClick)="onAction()" [loading]="isLoading"></pdq-button>
  </div>
</div>
